import React from "react";
import { useSelector } from "react-redux";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";
import OrderHeader from "./ViewOrder/OrderHeader";
import CustomerInformation from "./ViewOrder/CustomerInformation";
import StoreInformation from "./ViewOrder/StoreInformation";
import RiderInformation from "./ViewOrder/RiderInformation";
import OrderActions from "./ViewOrder/OrderActions";
import PaymentInfo from "./ViewOrder/PaymentInfo";
import OrderItemsTable from "./ViewOrder/OrderItemsTable";
import OrderSummary from "./ViewOrder/OrderSummary";
import OrderNotes from "./ViewOrder/OrderNotes";

export default function ViewOrders() {
  const singleOrder = useSelector((state) => state.admin.singleOrder);
  const loading = useSelector((state) => state.admin.loading);

  const hasRider =
    singleOrder?.status === "assigned" || singleOrder?.status === "delivered";

  return (
    <div className="main-content-padding">
      {loading ? (
        <PrimaryLoader />
      ) : (
        singleOrder && (
          <div className="text-left">
            <OrderHeader singleOrder={singleOrder} />
            <CustomerInformation singleOrder={singleOrder} />
            <StoreInformation singleOrder={singleOrder} />
            {hasRider && <RiderInformation singleOrder={singleOrder} />}

            <div className="order_contact mb-4">
              <div className="pt-3 mb-4">
                <div className="d-flex justify-content-between">
                  <h3 className="mb-2">Order Details</h3>
                  <div>
                    <OrderActions singleOrder={singleOrder} />
                  </div>
                </div>
              </div>

              <PaymentInfo singleOrder={singleOrder} />
              <OrderItemsTable singleOrder={singleOrder} />
              <OrderSummary singleOrder={singleOrder} />
              <OrderNotes singleOrder={singleOrder} />
            </div>
          </div>
        )
      )}
    </div>
  );
}
